"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
var AccessibilityModels_1 = require("../../Models/AccessibilityModels");
var ServiceImplBase_1 = require("./ServiceImplBase");
var AccessibilityServiceImpl = /** @class */ (function (_super) {
    __extends(AccessibilityServiceImpl, _super);
    function AccessibilityServiceImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AccessibilityServiceImpl.prototype, "serviceName", {
        get: function () {
            return "accessibility" /* Accessibility */;
        },
        enumerable: true,
        configurable: true
    });
    AccessibilityServiceImpl.prototype.getTooltipTextAsync = function (visualId, tupleId) {
        var _a;
        var tooltipTextRequest = new AccessibilityModels_1.TooltipTextRequestModel(visualId, tupleId);
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'getTooltipTextAsync',
            _a[api_internal_contract_js_1.ParameterId.TooltipTextRequest] = tooltipTextRequest,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.GetTooltipText, parameters).then(function (response) {
            return response.result;
        });
    };
    AccessibilityServiceImpl.prototype.leaveMarkNavigationAsync = function (visualId) {
        var _a;
        var parameters = (_a = {},
            _a[api_internal_contract_js_1.ParameterId.FunctionName] = 'leaveMarkNavigationAsync',
            _a[api_internal_contract_js_1.ParameterId.VisualId] = visualId,
            _a);
        return this.execute(api_internal_contract_js_1.VerbId.RaiseLeaveMarkNavNotification, parameters).then(function (response) {
            return;
        });
    };
    return AccessibilityServiceImpl;
}(ServiceImplBase_1.ServiceImplBase));
exports.AccessibilityServiceImpl = AccessibilityServiceImpl;
//# sourceMappingURL=AccessibilityServiceImpl.js.map